function Navigation_form_copy(element) {
    this.$element = $(element);

    this.selectors = {
   	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    containerNotice: '.js-notice',
	    containerMessage: '.js-message',
	    containerMessageOne: '.js-message-one',
	    checkboxOnlyPage: '.js-checkbox-only-page'
    };
    
    this.triggers = {
	    afterLoaded: 'i4:afterLoaded'
    };
    
    this.init = function() {    
	    
	    this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$containerNotice = this.$element.find(this.selectors.containerNotice);
	    this.$containerMessage = this.$element.find(this.selectors.containerMessage);
	    this.$containerMessageOne = this.$element.find(this.selectors.containerMessageOne);
	    this.$checkboxOnlyPage = this.$element.find(this.selectors.checkboxOnlyPage);
	    	    
	    this.$checkboxOnlyPage.on('i4:change', this.$onChangeCheckbox.bind(this)); 
	    
		this.$formParent.on(this.triggers.afterLoaded, (function() {
			this.$onChangeCheckbox();
		}).bind(this));
    };
    
    this.$onChangeCheckbox = function() {	    
    	if (this.$checkboxOnlyPage.is(':checked')) {
			this.$containerNotice.hide();
			this.$containerMessage.hide();
			this.$containerMessageOne.show();
		} else {
			this.$containerNotice.show();
			this.$containerMessage.show();
			this.$containerMessageOne.hide();
		}    
    };
}
